module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_19.cff0f313.jpg";